import { buildReducer } from '../../../shared';
import type { FavoritePickerState } from '../../state/favoritePickerState';
import {
    addFavoritePickerButtonClickedAction,
    favoritePickerDismissedAction,
    addFavoritePersonaClickedAction,
} from '../..';

export default buildReducer<FavoritePickerState>()
    .handle(addFavoritePickerButtonClickedAction, (state, action) => ({ showPicker: true }))
    .handle(favoritePickerDismissedAction, (state, action) => ({ showPicker: false }))
    .handle(addFavoritePersonaClickedAction, (state, action) => ({ showPicker: false }))
    .done({ showPicker: false });
export type { Action } from '../../../shared';
